import { NewQuizAndItemAnalysisPresenter } from './presenter';
import withAnalysisState from './withAnalysisState';
export var NewQuizAndItemAnalysis = withAnalysisState(NewQuizAndItemAnalysisPresenter);
export default NewQuizAndItemAnalysis;